import script from "./HeaderTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTasks.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTasks.vue?vue&type=style&index=0&id=0c2e74ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2e74ee"]])

export default __exports__